import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyImprovements = (
  data: IPropertyDetailsResponse
): string[] => {
  console.log(data?.improvements_list);
  return (
    data?.improvements_list
      ?.filter(improvement => improvement.name == "Mejoras")
      ?.map(improvement => improvement.value) || []
  );
};
